// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodProjectId } from './FoodProject';
import { foodNutritionalFormatId } from './FoodNutritionalFormat';
import { fileStorageId } from './FileStorage';
import { z } from 'zod';
export const foodBenchmarkId = (z.number());
export const foodBenchmark = z.object({
    id: foodBenchmarkId,
    project_id: foodProjectId,
    name: z.string(),
    display_order: z.number(),
    created_at: z.date().nullable(),
    format_id: foodNutritionalFormatId.nullable(),
    serving_size_g: z.string().nullable(),
    photo_file_id: fileStorageId.nullable(),
    website_url: z.string().nullable(),
});
export const foodBenchmarkInitializer = z.object({
    id: foodBenchmarkId.optional(),
    project_id: foodProjectId,
    name: z.string().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
    format_id: foodNutritionalFormatId.optional().nullable(),
    serving_size_g: z.string().optional().nullable(),
    photo_file_id: fileStorageId.optional().nullable(),
    website_url: z.string().optional().nullable(),
});
export const foodBenchmarkMutator = z.object({
    id: foodBenchmarkId.optional(),
    project_id: foodProjectId.optional(),
    name: z.string().optional(),
    display_order: z.number().optional(),
    created_at: z.date().optional().nullable(),
    format_id: foodNutritionalFormatId.optional().nullable(),
    serving_size_g: z.string().optional().nullable(),
    photo_file_id: fileStorageId.optional().nullable(),
    website_url: z.string().optional().nullable(),
});
//# sourceMappingURL=FoodBenchmark.js.map